import React from 'react'
import { IconCheck } from '@s4l/icons/IconCheck'
import styles from './index.module.css'

interface CheckboxProps {
  error?: boolean
  isFocused?: boolean
  name: string
  onChange: (params: { name: string }) => void
  onFocus?: () => void
  selected: boolean
  dataTestId?: string
  children?: React.ReactNode
  disabled?: boolean
}

const Checkbox = ({
  error,
  isFocused = false,
  name,
  onChange,
  onFocus,
  selected,
  dataTestId,
  children,
  disabled = false,
}: CheckboxProps) => {
  const checkboxBaseClasses = [
    styles.checkboxBase,
    disabled ? styles.disabled : '',
    selected ? styles.checked : '',
    isFocused ? styles.focused : '',
    error ? styles.error : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <label htmlFor={name} className={checkboxBaseClasses}>
      <input
        data-testid={dataTestId}
        aria-checked={selected}
        checked={selected}
        disabled={disabled}
        id={name}
        name={name}
        onChange={() => onChange({ name })}
        onFocus={onFocus}
        type="checkbox"
      />
      <IconCheck />
      {children}
    </label>
  )
}

export default Checkbox
